export { MessageType } from '@monorepo/api-client';

export enum MessageStatus {
  OK = 'OK',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export enum Provider {
  EXCEL = 'excel',
  XERO = 'xero',
  QUICKBOOKS = 'quickbooks',
  GOOGLE = 'google',
  CIN7 = 'dear',
  AZURE = 'azure',
  ZOHO = 'zoho',
  RECEIPTS = 'receipts',
  GROUP = 'group',
  HMRC = 'hmrc',
}

export enum ErrorCode {
  EMPTY_CODE,
  CONNECTION_ERROR,
  USER_ERROR,
  ORGANISATION_ERROR,
  KEY_ERROR,
  PROMO_ERROR,
  NO_ERROR,
}

export enum ReturnFrequency {
  BI_YEARLY = '2 Years',
  FORNIGHTLY = 'Fortnightly',
  MONTHLY = 'Monthly',
  TWO_MONTHS = '2 Months',
  FOUR_MONTHS = '4 Months',
  SIX_MONTHS = '6 Months',
  QUARTERLY = 'Quarterly',
  WEEKLY = 'Weekly',
  YEARLY = 'Yearly',
}

export enum AccountType {
  OWNER = 'Owner',
  STAFF = 'User',
  EXSTAFF = 'Ex-staff',
  SUPPORT = 'Support',
  ADMIN = 'Admin',
  DDEXPERT = 'DD-Expert',
  UNSPECIFIED = 'Unspecified',
  CLIENT = 'Client',
  REVENUE = 'Revenue',
  DIRECTCOSTS = 'Direct Costs',
  CURRENT = 'Current',
  CURRLIAB = 'Current Liab',
  EXPENSE = 'Expense',
  FIXED = 'Fixed',
  INCOME = 'Income',
  BANK = 'Bank',
  ACCOUNTS_RECEIVABLE = 'Accounts Receivable',
  OTHER_CURRENT_ASSET = 'Other Current Asset',
  FIXED_ASSET = 'Fixed Asset',
  OTHER_ASSET = 'Other Asset',
  ACCOUNTS_PAYABLE = 'Accounts Payable',
  CREDIT_CARD = 'Credit Card',
  OTHER_CURRENT_LIABILITY = 'Other Current Liability',
  LONG_TERM_LIABILITY = 'Long Term Liability',
  EQUITY = 'Equity',
  COST_OF_GOODS_SOLD = 'Cost of Goods Sold',
  OTHER_INCOME = 'Other Income',
  OTHER_EXPENSE = 'Other Expense',
  NON_POSTING = 'Non-Posting',
}

export enum PermissionType {
  ORGANISATIONS = 'organisations',
  USERS = 'users',
  MANAGER = 'managerView',
}

export enum TablePermission {
  READ = 'READ',
  WRITE = 'WRITE',
  ALL = 'ALL',
  NONE = 'NONE',
  OWNER_NONE = 'OWNER_NONE',
}

export enum DateOptions {
  ALL = 'All',
  TODAY = 'Today',
  THIS_MONTH = 'This month',
  LAST_MONTH = 'Last month',
  NEXT_MONTH = 'Next month',
  THIS_WEEK = 'This week',
  LAST_WEEK = 'Last week',
  NEXT_WEEK = 'Next week',
  THIS_QUARTER = 'This quarter',
  NEXT_QUARTER = 'Next quarter',
  THIS_YEAR = 'This year',
  LAST_YEAR = 'Last year',
}

export enum JournalType {
  SUMMARISED = 'Summarised ',
  DETAILED = 'Detailed',
}

// export enum SourceType {
//   ACCREC = 'Account Received',
//   CASHPAID = 'Cash Paid',
//   ACCPAY = 'Account Pay',
//   ACCRECCREDIT = 'Account Received credit',
//   CASHREC = 'Receive direct payment',
//   ARPREPAYMENT = 'Receive payment',
//   APPREPAYMENT = 'Spend payment',
//   AROVERPAYMENT = 'Receive overpayment',
//   APOVERPAYMENT = 'Spend overpayment',
//   MANJOURNAL = 'Manual journal',
//   ACCRECPAYMENT = 'Receive payment',
//   ACCPAYPAYMENT = 'Spend payment',
//   ARCREDITPAYMENT = 'Receive credit note payment',
//   APCREDITPAYMENT = 'Spend credit note payment',
//   CREDITNOTE_REVERSAL = 'Credit note reversal',
//   CREDITNOTE_ALLOCATION = 'Credit note allocation',
//   PREPAYMENT_ALLOCATION = 'Prepayment allocation',
//   OVERPAYMENT_ALLOCATION = 'Overpayment allocation',
// }
export enum SourceType {
  ACCREC = 'Accounts Receivable Invoice',
  ACCPAY = 'Accounts Payable Invoice',
  ACCRECCREDIT = 'Accounts Receivable Credit Note',
  ACCPAYCREDIT = 'Accounts Payable Credit Note',
  ACCRECPAYMENT = 'Payment on an Accounts Receivable Invoice',
  ACCPAYPAYMENT = 'Payment on an Accounts Payable Invoice',
  ARCREDITPAYMENT = 'Accounts Receivable Credit Note Payment',
  APCREDITPAYMENT = 'Accounts Payable Credit Note Payment',
  CASHREC = 'Receive Money Bank Transaction',
  CASHPAID = 'Spend Money Bank Transaction',
  TRANSFER = 'Bank Transfer',
  ARPREPAYMENT = 'Accounts Receivable Prepayment',
  APPREPAYMENT = 'Accounts Payable Prepayment',
  AROVERPAYMENT = 'Accounts Receivable Overpayment',
  APOVERPAYMENT = 'Accounts Payable Overpayment',
  EXPCLAIM = 'Expense Claim',
  EXPPAYMENT = 'Expense Claim Payment',
  MANJOURNAL = 'Manual Journal',
  PAYSLIP = 'Payslip',
  WAGEPAYABLE = 'Payroll Payable',
  INTEGRATEDPAYROLLPE = 'Payroll Expense',
  INTEGRATEDPAYROLLPT = 'Payroll Payment',
  EXTERNALSPENDMONEY = 'Payroll Employee Payment',
  INTEGRATEDPAYROLLPTPAYMENT = 'Payroll Tax Payment',
  INTEGRATEDPAYROLLCN = 'Payroll Credit Note',
  CREDITNOTE_REVERSAL = 'Credit note reversal',
  CREDITNOTE_ALLOCATION = 'Credit note allocation',
  PREPAYMENT_ALLOCATION = 'Prepayment allocation',
  OVERPAYMENT_ALLOCATION = 'Overpayment allocation',
}

export enum XeroSourceType {
  ACCREC = 'Accounts Receivable Invoice',
  ACCPAY = 'Accounts Payable Invoice',
  ACCRECCREDIT = 'Accounts Receivable Credit Note',
  ACCPAYCREDIT = 'Accounts Payable Credit Note',
  ACCRECPAYMENT = 'Payment on an Accounts Receivable Invoice',
  ACCPAYPAYMENT = 'Payment on an Accounts Payable Invoice',
  ARCREDITPAYMENT = 'Accounts Receivable Credit Note Payment',
  APCREDITPAYMENT = 'Accounts Payable Credit Note Payment',
  CASHREC = 'Receive Money Bank Transaction',
  CASHPAID = 'Spend Money Bank Transaction',
  TRANSFER = 'Bank Transfer',
  ARPREPAYMENT = 'Accounts Receivable Prepayment',
  APPREPAYMENT = 'Accounts Payable Prepayment',
  AROVERPAYMENT = 'Accounts Receivable Overpayment',
  APOVERPAYMENT = 'Accounts Payable Overpayment',
  EXPCLAIM = 'Expense Claim',
  EXPPAYMENT = 'Expense Claim Payment',
  MANJOURNAL = 'Manual Journal',
  PAYSLIP = 'Payslip',
  WAGEPAYABLE = 'Payroll Payable',
  INTEGRATEDPAYROLLPE = 'Payroll Expense',
  INTEGRATEDPAYROLLPT = 'Payroll Payment',
  EXTERNALSPENDMONEY = 'Payroll Employee Payment',
  INTEGRATEDPAYROLLPTPAYMENT = 'Payroll Tax Payment',
  INTEGRATEDPAYROLLCN = 'Payroll Credit Note',
  CREDITNOTE_REVERSAL = 'Credit note reversal',
  CREDITNOTE_ALLOCATION = 'Credit note allocation',
  PREPAYMENT_ALLOCATION = 'Prepayment allocation',
  OVERPAYMENT_ALLOCATION = 'Overpayment allocation',
}

export const QboSourceType = {
  Invoice: 'Invoice',
  Expense: 'Expense',
  'Journal Entry': 'Journal Entry',
  Cheque: 'Cheque',
  'Sales Receipt': 'Sales Receipt',
  Deposit: 'Deposit',
  Bill: 'Bill',
  'Supplier Credit': 'Supplier Credit',
  'Credit Note': 'Credit Note',
  Refund: 'Refund',
  'Credit Card Credit': 'Credit Card Credit',
} as const;

export const ZohoSourceType = {
  invoice: 'Invoice',
  bill: 'Bill',
  expense: 'Expense',
  creditnote: 'Credit Note',
  vendor_credit: 'Vendor Credit',
  customer_payment: 'Customer Payment',
  vendor_payment: 'Vendor Payment',
  journal: 'Journal',
  sales_receipt: 'Sales Receipt',
};

export enum SubscriptionPlan {
  FREE_PLAN = 'Free',
  SMALL_PLAN = 'Small',
  MEDIUM_PLAN = 'Medium',
  LARGE_PLAN = 'Large',
  ENTERPRISE_PLAN = 'Enterprise',
}

export enum Currency {
  EUR = 'EUR',
  AED = 'AED',
  USD = 'USD',
}

export enum AddOnsType {
  VAT_NUMBER_CHECKER = 'VAT Number Checker',
  ADDITIONAL_ENTITIES = 'Additional Entities',
}

export enum ContactUsMessageType {
  ENTERPRISE = 'ENTERPRISE',
  CANCELATION = 'CANCELATION',
  HELP = 'HELP',
}

export enum UpgradeMessageSource {
  EXCEPTIONS = 'EXCEPTIONS',
  VAT_CHECKER = 'VAT_CHECKER',
  VAT_CHECKER_ACTIVATE = 'VAT_CHECKER_ACTIVATE',
  ATTACHMENT_VIEW = 'ATTACHMENT_VIEW',
  ATTACHMENT_UPLOAD = 'ATTACHMENT_UPLOAD',
  CLIENT_FLOW = 'CLIENT_FLOW',
  ADVANCED_USER_RIGHTS = 'ADVANCED_USER_RIGHTS',
  MANAGER_VIEW = 'MANAGER_VIEW',
  DELETE_ENTITY = 'DELETE_ENTITY',
  DELETE_ENTITY_ONLY = 'DELETE_ENTITY_ONLY',
  CHANGE_TO_VIEW_ONLY = 'CHANGE_TO_VIEW_ONLY',
  REACTIVATE_ENTITY = 'REACTIVATE_ENTITY',
  COMPARE_RETURN = 'COMPARE_RETURN',
  OSS_RETURN = 'OSS_RETURN',
}
